import { AccountingEventsGroup } from "../types/events";
import {
  DigitalBusinessDocument,
  DigitalCostDocument,
  DigitalPaymentDocument,
} from "../types/documents";
import { isAccountingEventsGroup } from "./typeChecks";

/**
 * Determines if an order is a free trial by checking for isFreeTrial flag in accounting events
 */
export function isFreeTrial(
  events: (
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
    | DigitalPaymentDocument
  )[]
): boolean {
  return events.some((event) => {
    if (isAccountingEventsGroup(event)) {
      return Object.values(event.accountingEvents).some(
        (e) => e.isFreeTrial === true || e.billAmount?.value === "0.00"
      );
    }
    return false;
  });
}
